import {
  OrganizationId,
  OrganizationTypes,
  TeamId,
  UserId,
} from '@mntn-dev/domain-types'

import { getPrivileges } from '@mntn-dev/authorization-types'
import { MockModel, MockUser } from '@mntn-dev/domain-mocks'
import { getRandomItem } from '@mntn-dev/utilities'
import type { Principal, SessionPrincipal } from './principal.ts'

export const MockPrincipal = MockModel<Principal>(
  ({
    userId = UserId(),
    emailAddress = `user+${userId}@example.com`,
    organizationId = OrganizationId(),
    organizationType = getRandomItem(OrganizationTypes),
    teamIds = [],
    isActive = true,
  }) => {
    return {
      userId,
      emailAddress,
      organizationId,
      organizationType,
      teamIds,
      privileges: getPrivileges(organizationType),
      user: MockUser({ userId, emailAddress, organizationId }),
      isActive,
    } satisfies Principal
  }
)

export const MockSessionPrincipal = MockModel<SessionPrincipal>(
  ({
    userId = UserId(),
    emailAddress = `user+${userId}@example.com`,
    organizationId = OrganizationId(),
    organizationType = getRandomItem(OrganizationTypes),
    teamIds = [TeamId()],
    scopes = [],
    isActive = true,
  }) => {
    return {
      userId,
      emailAddress,
      organizationId,
      organizationType,
      teamIds,
      scopes,
      privileges: getPrivileges(organizationType),
      user: MockUser({
        userId,
        emailAddress,
        organizationId,
        organizationType,
      }),
      isActive,
    } satisfies SessionPrincipal
  }
)
